/**
 * Citrus spill — playful burst of tiny oranges when a form control is
 * focused or a choice (radio/checkbox/select) is made. Self-contained:
 * particles are styled inline, removed when their animation ends.
 */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const COLORS = ['#E8720C', '#F7A34C', '#F7C948'];

  function spill(el) {
    const rect = el.getBoundingClientRect();
    if (!rect.width || !el.isConnected) return;

    const count = 6 + Math.floor(Math.random() * 4);
    for (let i = 0; i < count; i += 1) {
      const particle = document.createElement('span');
      const size = 6 + Math.random() * 8;
      const color = COLORS[i % COLORS.length];
      const x = rect.left + rect.width * (0.15 + Math.random() * 0.7);

      particle.setAttribute('aria-hidden', 'true');
      particle.style.cssText = [
        'position: fixed',
        `left: ${x}px`,
        `top: ${rect.top}px`,
        `width: ${size}px`,
        `height: ${size}px`,
        'border-radius: 50%',
        'pointer-events: none',
        'z-index: 9999',
        `background: radial-gradient(circle at 30% 30%, ${color}, color-mix(in srgb, ${color}, black 30%))`,
      ].join(';');
      document.body.appendChild(particle);

      const drift = (Math.random() - 0.5) * 140;
      const rise = 30 + Math.random() * 50;
      const fall = 50 + Math.random() * 70;
      const spin = (Math.random() - 0.5) * 360;

      particle
        .animate(
          [
            { transform: 'translate(0, 0) scale(0.4) rotate(0deg)', opacity: 1 },
            {
              transform: `translate(${drift * 0.6}px, -${rise}px) scale(1) rotate(${spin * 0.5}deg)`,
              opacity: 1,
              offset: 0.35,
            },
            { transform: `translate(${drift}px, ${fall}px) scale(0.85) rotate(${spin}deg)`, opacity: 0 },
          ],
          { duration: 600 + Math.random() * 300, easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)' }
        )
        .onfinish = () => particle.remove();
    }
  }

  document.addEventListener('focusin', (event) => {
    const el = event.target;
    if (
      el.matches(
        'input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="button"]), textarea'
      )
    ) {
      spill(el);
    }
  });

  // other components (e.g. the cart drawer) can request a burst by dispatching
  // a bubbling 'citrus:spill' event from the element to burst from
  document.addEventListener('citrus:spill', (event) => {
    spill(event.detail?.el || event.target);
  });

  document.addEventListener('change', (event) => {
    const el = event.target;
    if (el.matches('select, input[type="checkbox"], input[type="radio"]')) {
      // choice inputs are often visually hidden inside a styled label; burst from the visible control
      spill(el.closest('label') || el);
    }
  });
})();
